"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _locationManager = _interopRequireDefault(require("./locationManager"));

var _login = _interopRequireDefault(require("../login"));

var _selectors = require("../../redux/login/selectors");

var _actions = require("../../redux/login/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AdminLite = function AdminLite() {
  var _useLoginSelector = (0, _selectors.useLoginSelector)(),
      loggedIn = _useLoginSelector.loggedIn,
      authEmail = _useLoginSelector.authEmail;

  var history = (0, _reactRouter.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (authEmail) {
      dispatch((0, _actions.signInWithEmailLink)(authEmail));
    }
  }, [dispatch, authEmail]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-page flex flex-col bg-appPage h-full flex-1"
  }, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "sticky",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, {
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "home-toolbar-title-container text-align-left flex w-full"
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    onClick: function onClick() {
      return history.push('/');
    }
  }, /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
    htmlColor: "#ffffff"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "home-toolbar-title flex align-items-center flex1 ml-3 text-xl"
  }, "Location Manager"), loggedIn && /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-1 justify-end pr-3"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "default",
    variant: "text",
    onClick: function onClick() {
      return dispatch((0, _actions.logout)());
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-white"
  }, "Logout")))))), !loggedIn ? /*#__PURE__*/_react.default.createElement(_login.default, {
    hideToolbar: true
  }) : /*#__PURE__*/_react.default.createElement(_locationManager.default, null));
};

var _default = AdminLite;
exports.default = _default;